import ProjectMana from '@/Views/Project/ProjectMana.vue'
import AbsenceMana from '@/Views/Absence/AbsenceMana.vue'
import AbsenceMana1 from '@/Views/Absence/AbsenceMana1.vue'
import WorkloadMana from '@/Views/Workload/WorkloadMana.vue'
import PayrollMana from '@/Views/Payroll/PayrollMana.vue'
import StatisticsTask from '@/Views/Statistics/StatisticsTask.vue'
import StatisticsProject from '@/Views/Statistics/StatisticsProject.vue'
import WorkListMana from '@/Views/WorkList/WorkListMana.vue'


import store from '@/store/index'
import VueRouter from 'vue-router'

const defaultRouters = [{
        path: '/home',
        name: 'home',
        component: () =>
            import ('@/views/Layout/Home.vue'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/',
        name: 'login',
        component: () =>
            import ('@/views/Login.vue'),
        meta: {
            title: '登录'
        }
    }
]

export const businessRouter = [
    {
        path: '/UserMana',
        name: 'userMana',
        component: () =>
            import ('@/Views/User/UserMana.vue'),
        meta: {
            iconCls: 'fa fa-user',
            title: '用户管理',
            permission: '8a004957-162d-5b93-5d45-787eb077ec22'
        }
    },
    {
        path: '/projects',
        meta: {
            title: '项目管理',
            iconCls: 'fa fa-address-card',
        },
        children: [{
                path: '/projects/pending',
                component: ProjectMana,
                meta: {
                    iconCls: 'fa fa-address-card',
                    title: '待处理',
                    params: JSON.stringify({
                        type: 0
                    })
                }
            },
            {
                path: '/projects/track',
                component: ProjectMana,
                meta: {
                    iconCls: 'fa fa-address-card',
                    title: '潜在跟踪',
                    params: JSON.stringify({
                        type: 1
                    })
                }
            },
            {
                path: '/projects/purchase_processing',
                component: ProjectMana,
                meta: {
                    iconCls: 'fa fa-address-card',
                    title: '采购流程',
                    params: JSON.stringify({
                        type: 2
                    })
                }
            },
            {
                path: '/projects/processing',
                component: ProjectMana,
                meta: {
                    iconCls: 'fa fa-address-card',
                    title: '正在执行项目',
                    params: JSON.stringify({
                        type: 5
                    })
                }
            },
            {
                path: '/projects/acceptance',
                component: ProjectMana,
                meta: {
                    iconCls: 'fa fa-address-card',
                    title: '验收流程',
                    params: JSON.stringify({
                        type: 6
                    })
                }
            },
            {
                path: '/projects/archive',
                component: ProjectMana,
                meta: {
                    title: '归档项目',
                    iconCls: 'fa fa-address-card',
                    params: JSON.stringify({
                        type: 7
                    })
                }
            }
        ]
    },
    {
        path: '/absence',
        meta: {
            title: '考勤管理',
            iconCls: 'fa fa-calculator', // fa fa-bar-chart
        },
        children: [{
                path: '/absence/list',
                meta: {
                    iconCls: 'fa fa-user',
                    title: '请假管理',
                    permission: '8a004957-162d-5b93-5d45-787eb077ec22',
                    props: { type: 1 }
                },
                component: AbsenceMana
            },
            {
                path: '/absence/list_all',
                meta: {
                    permission: '8a004957-162d-5b93-5d45-787eb077ec22',
                    iconCls: 'fa fa-user',
                    title: '休假管理(不计工龄)',
                },
                component: AbsenceMana1
            }
        ]
    },
    {
        // fa fa-bar-chart
        path: '/workload',
        redirect: '/workload/list',
        meta: {
            title: '工作量管理',
            iconCls: 'fa fa-calculator',
        },
        children: [{
            path: '/workload/list',
            component: WorkloadMana,
            meta: {
                iconCls: 'fa fa-user',
                title: '工作量管理',
                permission: '8a004957-162d-5b93-5d45-787eb077ec22'
            }
        }]
    },
    {
        path: '/payroll',
        redirect: '/payroll/list',
        meta: {
            title: '工资管理',
            iconCls: 'fa fa-calculator', // fa fa-bar-chart
        },
        component: PayrollMana
    },
    {
        path: '/notice',
        redirect: '/notice/list',
        meta: {
            title: '消息与通知管理',
            iconCls: 'fa fa-commenting', // fa fa-bar-chart
        },
        component: () =>
            import ('@/Views/Notice/index.vue')
    },
    {
        path: '/statistics',
        meta: {
            title: '数据统计',
            iconCls: 'fa fa-calculator', // fa fa-bar-chart
        },
        children: [{
                path: '/statistics/task',
                component: StatisticsTask,
                meta: {
                    iconCls: 'fa fa-user',
                    title: '工作量统计',
                    permission: '8a004957-162d-5b93-5d45-787eb077ec22'
                }
            },
            {
                path: '/statistics/project',
                component: StatisticsProject,
                meta: {
                    iconCls: 'fa fa-user',
                    title: '活跃用户统计',
                    permission: '8a004957-162d-5b93-5d45-787eb077ec22'
                }
            }
        ]
    },
    {
        path: '/workList',
        meta: {
            title: '工作清单',
            iconCls: 'fa fa-calculator', // fa fa-bar-chart,
        },
        component: WorkListMana
    },
    {
        path: '/scene',
        meta: {
            title: '现场管理',
            iconCls: 'fa fa-calculator', // fa fa-bar-chart
            permission: '8a004957-162d-5b93-5d45-787eb077ec22'
        },
        children: [{
            path: '/scene/list',
            component: WorkListMana,
            meta: {
                iconCls: 'fa fa-user',
                title: '项目日报'
            }
        }]
    }
];

const preprocessRoutes = (route) => {
    route.components = {}
    route.components["tabitem"] = route.component
    delete route.component
    if (route.children && route.length > 0) {
        for (var index in route.children) {
            return preprocessRoutes(route.children)
        }
    } else {
        return route
    }
}

const preHandleRoutes = () => {
    businessRouter.forEach(element => {
        preprocessRoutes(element)
    });
}

//preHandleRoutes()

//console.log(businessRouter)

export const router = new VueRouter({
    //mode: "history",
    routes: [
        ...defaultRouters,
        ...businessRouter
    ]
})

router.beforeEach(async(to, from, next) => {
    if (to.name === 'login') {
        next()
    } else {
        let token = store.state.user.token
        if (!token || !/\S/u.test(token)) {
            next({ path: '/', replace: true })
        } else {
            next()
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js